__turbopack_context__.v({
  "header": "CodeBlockHeader-module__WoEbma__header",
  "headerContainer": "CodeBlockHeader-module__WoEbma__headerContainer",
  "headerContainerRoundedTop": "CodeBlockHeader-module__WoEbma__headerContainerRoundedTop",
  "label": "CodeBlockHeader-module__WoEbma__label",
  "pendingIndicator": "CodeBlockHeader-module__WoEbma__pendingIndicator",
  "spin": "CodeBlockHeader-module__WoEbma__spin",
  "spinner": "CodeBlockHeader-module__WoEbma__spinner",
  "srOnly": "CodeBlockHeader-module__WoEbma__srOnly",
  "tabContainer": "CodeBlockHeader-module__WoEbma__tabContainer",
});
